/**
 * What a request asks for, read from its action payload (`@confluent/shared/lib/payload-fields`): a two-column field list in the
 * NextAdmin key/value style (`profile/account` details), lists of like rows as compact `DataTable`s, nested objects
 * indented. Long values wrap inside the dialog instead of widening it.
 */
import { DataTable } from '../ui/DataTable.js';
import { type PayloadField, payloadFields } from '@confluent/shared/lib/payload-fields';

function FieldRows({ fields }: { fields: PayloadField[] }) {
  return (
    <>
      {fields.map((field) => {
        if (field.kind === 'text') {
          return (
            <div key={field.key} className="contents">
              <dt className="text-text-tertiary">{field.label}</dt>
              <dd className="min-w-0 font-mono text-text-primary break-words">{field.text}</dd>
            </div>
          );
        }
        return (
          <div key={field.key} className="col-span-2 min-w-0 space-y-1.5">
            <dt className="text-text-tertiary">{field.label}</dt>
            <dd className="min-w-0">
              {field.kind === 'table' ? (
                <DataTable
                  aria-label={field.label}
                  columns={field.columns.map((column, index) => ({
                    key: column.key,
                    header: column.label,
                    render: (row: string[]) => <span className="font-mono break-words">{row[index]}</span>,
                  }))}
                  rows={field.rows}
                  rowKey={(_row, index) => index}
                  framed
                />
              ) : (
                <dl className="grid grid-cols-[minmax(0,6rem)_minmax(0,1fr)] sm:grid-cols-[minmax(0,9rem)_minmax(0,1fr)] gap-x-4 gap-y-1.5 border-l border-card-border pl-3">
                  <FieldRows fields={field.fields} />
                </dl>
              )}
            </dd>
          </div>
        );
      })}
    </>
  );
}

export function DecisionPayload({ payload }: { payload: Record<string, unknown> | null }) {
  const fields = payloadFields(payload);
  if (fields.length === 0) return null;
  return (
    <dl className="grid grid-cols-[minmax(0,7rem)_minmax(0,1fr)] sm:grid-cols-[minmax(0,10rem)_minmax(0,1fr)] gap-x-4 gap-y-1.5 rounded-lg border border-card-border bg-background-gray-primary p-3 text-xs">
      <FieldRows fields={fields} />
    </dl>
  );
}
